import { useEffect, useState } from "react";
import { BsPlusSquare } from "react-icons/bs";
import NoBannerIcon from "./../../../assets/icons/no-banner.svg";
import {
  CreateHomeBanner,
  DeleteHomeBanner,
  HomeBanner,
  UpdateHomeBanner,
} from "./home_banners";
import { useQuery } from "react-query";
import { fetchBanner } from "../../../api/setting";

const Banners = () => {
  const [showCreateBanner, setShowCreateBanner] = useState(false);
  const [showUpdateBanner, setShowUpdateBanner] = useState(false);
  const [showDeleteBanner, setShowDeleteBanner] = useState(false);
  const [bannerData, setBannerData] = useState(null);
  const [permissions, setPermissions] = useState(null);

  useEffect(() => {
    const ls = localStorage.getItem("permissions");
    try {
      const parsedLs = JSON.parse(ls);
      setPermissions(parsedLs);
    } catch (error) {}
  }, []);

  const getModulePermission = (module, section) => {
    const pers = permissions?.find(
      (per) =>
        String(per?.module?.toLowerCase()) === String(module.toLowerCase()),
    )?.permissions;
    return pers ? pers[section] : false;
  };

  const [type, setType] = useState("home");
  const { data: homeData } = useQuery("banners-home", () =>
    fetchBanner("home"),
  );
  const { data: shopData } = useQuery("banners-shop", () =>
    fetchBanner("shop"),
  );
  return (
    <div className="flex flex-col gap-10">
      {showCreateBanner ? (
        <CreateHomeBanner
          section={type}
          handleClose={() => setShowCreateBanner(false)}
        />
      ) : (
        <></>
      )}
      {showUpdateBanner ? (
        <UpdateHomeBanner
          section={type}
          handleClose={() => setShowUpdateBanner(false)}
          prevBanner={bannerData}
        />
      ) : (
        <></>
      )}
      {showDeleteBanner ? (
        <DeleteHomeBanner
          section={type}
          handleClose={() => setShowDeleteBanner(false)}
          prevBanner={bannerData}
        />
      ) : (
        <></>
      )}
      <div className="bg-white rounded-lg py-5 px-7 space-y-5">
        <div className="font-bold text-[16px]">Home</div>
        <div className="flex whitespace-nowrap overflow-x-auto">
          {(homeData?.banners || []).map((band, k) => {
            return (
              <div className="space-y-3" key={k}>
                <HomeBanner
                  bannerColor={band.color}
                  bannerText={band.description}
                  bannerTitle={band.title}
                />
                <div className="flex gap-3 items-center  text-[14px] font-bold">
                  <button
                    className="text-[#2121F1]"
                    onClick={() => {
                      setShowUpdateBanner(true);
                      setBannerData(band);
                    }}
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => {
                      setShowDeleteBanner(true);
                      setBannerData(band);
                    }}
                    className="text-[#7B7B7B]"
                  >
                    Delete
                  </button>
                </div>
              </div>
            );
          })}
          {getModulePermission("banner", "canCreate") && (
            <div
              className={
                "w-[330px] min-w-[330px] max-w-[330px] mr-4 h-[150px] rounded-[20px] space-y-3 cursor-pointer" +
                " border-dashed border-[2px] border-black p-4 flex flex-col justify-center items-center"
              }
              onClick={() => {
                setType("home");
                setShowCreateBanner(true);
              }}
            >
              <div className="text-[25px]">
                <BsPlusSquare />
              </div>
              <div className="text-dark">Create new banner</div>
            </div>
          )}
        </div>
      </div>
      <div className="bg-white rounded-lg py-5 px-7 space-y-5 w-full">
        <div className="font-bold text-[16px]">Shop</div>
        {shopData?.banners?.length ? (
          <>
            {(shopData?.banners || []).map((band, k) => {
              return (
                <div className="space-y-3" key={k}>
                  <HomeBanner
                    bannerColor={band.color}
                    bannerText={band.description}
                    bannerTitle={band.title}
                  />
                  <div className="flex gap-3 items-center  text-[14px] font-bold">
                    <button
                      className="text-[#2121F1]"
                      onClick={() => {
                        setShowUpdateBanner(true);
                        setBannerData(band);
                      }}
                    >
                      Edit
                    </button>
                    <button
                      className="text-[#7B7B7B]"
                      onClick={() => {
                        setType("shop");
                        setShowDeleteBanner(true);
                        setBannerData(band);
                      }}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              );
            })}
          </>
        ) : (
          <EmptyBanner
            setShowCreateBanner={setShowCreateBanner}
            setType={setType}
          />
        )}
      </div>
    </div>
  );
};

export default Banners;

function EmptyBanner({ setType, setShowCreateBanner }) {
  return (
    <div className="w-full flex flex-col justify-center items-center">
      <div className="w-1/2 text-center gap-4 flex flex-col items-center">
        <img src={NoBannerIcon} className="w-[87px] pointer-events-none" />
        <div className="w-fit leading-[32px]">
          Currently, your canvas is blank, Craft eye-catching banners for
          promotions, announcements, and events.
        </div>
        <button
          onClick={() => {
            setType("shop");
            setShowCreateBanner(true);
          }}
          className="rounded-[5px] p-2 text-white font-bold bg-dark text-[15px]"
        >
          Create new bannner
        </button>
      </div>
    </div>
  );
}
